<template>
  <div class="flex bg-red-light p-4 text-white text-center" v-if="isOffline">
    <i class="la la-plug mx-1"></i> POS is offline
  </div>
</template>

<script>
export default {
  props: [
    'top'
  ],
}
</script>
